import ParentCustomerDetails from "../../views/Client/ParentCustomerDetails";

const ParentCustomerDetailsPage = () => <ParentCustomerDetails />;

export default ParentCustomerDetailsPage;
